// extracted by mini-css-extract-plugin
export default {"main":"BreadCrumb_main__HTlP1","breadCrumb":"BreadCrumb_breadCrumb__qJhYm","crumb":"BreadCrumb_crumb__xCDAU","separator":"BreadCrumb_separator__mPv3W"};